export const version = "providers/5.8.0";
//# sourceMappingURL=_version.js.map